import BaseScenarioPart from "../../../../cvp-webgames-core/Scenario/BaseScenarioPart";
import { getNextPartId } from "../../../../misc/tools";
import { DaarcBaseScenario } from "../../../DaarcBaseScenario";
import { BaseGeneralConfig, GeneralPartConfig } from "../../general-scenario-stuff";
import { GeneralStepCollection } from "../../GeneralStepCollection";
import GeneralProceduresSgaPart1 from "./parts/GeneralProceduresSgaPart1";

export default class GeneralProceduresSgaMain extends GeneralStepCollection {
	private _parts: BaseScenarioPart<DaarcBaseScenario>[] = [];
	private _partId1 = getNextPartId();

	public get parts() {
		return this._parts;
	}
	constructor(public config: GeneralProceduresSgaMainConfig) {
		super();
		var context = this;
		context._parts.push(new GeneralProceduresSgaPart1(this, config.scenario, () => {
			config.onDone();
		}, () => {
			if(config.onAbort) {
				config.onAbort();
			}
		}, context._partId1, config))
	}

	public start() {
		this.goToStep1();
	}

	goToStep1() {
		this.config.scenario.loadPart(this._partId1);
	}
}

export interface GeneralProceduresSgaMainConfig extends BaseGeneralConfig {
	scenario: DaarcBaseScenario;
	part1Config?: GeneralProceduresSgaPart1Config;
	onChangeSGASizeClicked?: () => void;
	onUpDownManeuverClickedInOptimizations?: () => void;
	onChooseAnotherTechniqueClicked?: () => void;
	isAttemptSuccessful: () => boolean;
	isTempSuccess: () => boolean;
	onDone: () => void;
	onAbort: () => void;
}

export interface GeneralProceduresSgaPart1Config extends GeneralPartConfig {
	attempt1AudioPath?: string;
	attempt2AudioPath?: string;
	attempt3AudioPath?: string;
	attempt4AudioPath?: string;
	isAngelaScott?: boolean;
	presetupText?: string;
	onAbortClicked?: () => void;
	onMakeAttemptClicked?: (selectedSga: string) => void;
	onProcedureAttempted?: (attemptCount: number) => void;
	onProcedureAttemptedMoreThan3Times?: () => void;
	squeezeAmbuBagVideoChapter: () => string;
	insertingSgaVideoChapter: () => string;
}